import * as React from 'react';

export const Alert: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="alert alert-danger" role="alert">
      <span>{children}</span>
    </div>
  );
};

export default Alert;
